module.exports = __webpack_public_path__ + "img/reg3PS-2.c7686034.jpg";